
import BaseApi from "../BaseApi";

export default class EmployeeSurveyService extends BaseApi {


    constructor(){
        super();
    }
 
    /**
     * GET
     * Get survey data
     */
    async getBody(id)
    {
        return this.http.get(`${this.baseUrl}/app/employees/surveys/${id}`)
        .catch(this.handleErrorResponse);
    }

    /**
     * GET
     * Get survey data
    */
    async getDetails(id)
    {
        return this.http.get(`${this.baseUrl}/app/employees/surveys/${id}`)
        .catch(this.handleErrorResponse);
    }

    /**
     * STORE
     * store survey answers
     */
    async sendAnswers(id, data)
    {
        return this.http.post(`${this.baseUrl}/app/employees/surveys/${id}/answers`, data)
        .catch(this.handleErrorResponse);
    }
}